/**
 * Hook: useFormMessage
 *
 * Standardized form feedback with automatic tone classification
 *
 * @returns {Object} { message, tone, setMessage, setError, setWarning, setSuccess, clear }
 */

import { useCallback, useState } from 'react'

const classifyMessageTone = (message) => {
  if (!message) return ''

  const lower = message.toLowerCase()

  // Error conditions
  if (lower.includes('unable') ||
      lower.includes('unexpected') ||
      lower.includes('failed') ||
      lower.includes('error')) {
    return 'gg-inline-alert--error'
  }

  // Warning conditions
  if (lower.includes('required') ||
      lower.includes('valid') ||
      lower.includes('unavailable') ||
      lower.includes('missing')) {
    return 'gg-inline-alert--warning'
  }

  // Success conditions
  if (lower.includes('success') ||
      lower.includes('created') ||
      lower.includes('updated') ||
      lower.includes('saved')) {
    return 'gg-inline-alert--success'
  }

  // Default to neutral
  return 'gg-inline-alert--info'
}

export const useFormMessage = () => {
  const [message, setMessageState] = useState('')

  const setMessage = useCallback((text) => {
    setMessageState(text)
  }, [])

  const setError = useCallback((text) => {
    setMessageState(text)
  }, [])

  const setWarning = useCallback((text) => {
    setMessageState(text)
  }, [])

  const setSuccess = useCallback((text) => {
    setMessageState(text)
  }, [])

  const clear = useCallback(() => {
    setMessageState('')
  }, [])

  const tone = classifyMessageTone(message)

  return {
    message,
    tone,
    setMessage,
    setError,
    setWarning,
    setSuccess,
    clear
  }
}